import React from "react";
import { Box, Typography } from "@mui/material";

interface ScoreBadgeProps {
  score: number;
  size?: number;
}

export const scoreColorKey = (score: number): "success" | "warning" | "error" =>
  score >= 80 ? "success" : score >= 50 ? "warning" : "error";

const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score, size = 40 }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: "50%",
      border: "2px solid",
      borderColor: (theme) => theme.palette[scoreColorKey(score)].main,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    <Typography variant="caption" fontWeight={800} color={`${scoreColorKey(score)}.main`}>
      {score}
    </Typography>
  </Box>
);

export default ScoreBadge;
